import { useQueryClient } from "@tanstack/react-query";
import { useMesfRealtime } from "@dexteel/mesf-core";

/**
 * Maps stored procedure names to TanStack Query key prefixes for automatic invalidation.
 * When the backend executes one of these SPs, it sends a SignalR message
 * that triggers cache invalidation for all connected clients.
 */
const SP_TO_QUERY_KEYS: Record<string, readonly string[][]> = {
  "DEL.GetDelaysByShift": [["delays-by-shift"], ["delay"]],
  "DEL.GetDelays": [["delays-report"]],
  "DEL.GetDelaysForPareto": [["delays-for-pareto"]],
  "DEL.GetDelayCategories": [["delay-categories"]],
  "DEL.GetDelayCodes": [["delay-codes"], ["delay-code"]],
};

/**
 * Hook that listens to SignalR messages and invalidates TanStack Query cache.
 * This enables real-time updates across multiple users without polling.
 *
 * Usage: Call this hook once at the page level where you want real-time updates.
 */
export const useRealtimeInvalidation = () => {
  const queryClient = useQueryClient();

  useMesfRealtime({
    onReceiveMessage: (_author: string, message: string) => {
      const queryKeys = SP_TO_QUERY_KEYS[message];
      if (queryKeys) {
        for (const queryKey of queryKeys) {
          queryClient.invalidateQueries({ queryKey });
        }
      }
    },
  });
};
